export const ROLES = {
  SuperAdmin: "SuperAdmin",
  Examiner: "Examiner",
  SectionOfficer: "SectionOfficer",
  HeadExaminer: "HeadExaminer",
};
